import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { AgCharts } from 'ag-charts-angular';
import { AgBarSeriesOptions, AgChartOptions, AgLineSeriesOptions } from 'ag-charts-community';

@Component({
  selector: 'app-stats-component',
  imports: [AgCharts, NgFor],
  templateUrl: './stats-component.html',
  styleUrl: './stats-component.scss',
})
export class StatsComponent {
  monthlyBookings = [
    { month: 'Jan', bookings: 42, cancelled: 5, referrals: 3 },
    { month: 'Feb', bookings: 55, cancelled: 8, referrals: 4 },
    { month: 'Mar', bookings: 61, cancelled: 3, referrals: 5 },
    { month: 'Apr', bookings: 48, cancelled: 6, referrals: 2 },
    { month: 'May', bookings: 73, cancelled: 9, referrals: 6 },
    { month: 'Jun', bookings: 67, cancelled: 4, referrals: 3 },
    { month: 'Jul', bookings: 82, cancelled: 7, referrals: 5 },
    { month: 'Aug', bookings: 90, cancelled: 6, referrals: 4 },
    { month: 'Sep', bookings: 76, cancelled: 5, referrals: 3 },
    { month: 'Oct', bookings: 104, cancelled: 10, referrals: 7 },
    { month: 'Nov', bookings: 87, cancelled: 8, referrals: 5 },
    { month: 'Dec', bookings: 95, cancelled: 6, referrals: 6 },
  ];

  monthlyBookingsChartOptions: AgChartOptions = {
    data: this.monthlyBookings,
    series: [
      {
        type: 'line',
        xKey: 'month',
        yKey: 'bookings',
        yName: 'Completed bookings',
      } as AgLineSeriesOptions,
      {
        type: 'line',
        xKey: 'month',
        yKey: 'cancelled',
        yName: 'Cancelled',
        stroke: 'red',
      } as AgLineSeriesOptions,
      {
        type: 'line',
        xKey: 'month',
        yKey: 'referrals',
        yName: 'Referrals',
        stroke: 'green',
      } as AgLineSeriesOptions,
    ],
    legend: {
      enabled: true,
    },
  };

  // Dummy top diagnoses data
  topDiagnoses = [
    { diagnosis: 'Flu', count: 125 },
    { diagnosis: 'Diabetes', count: 98 },
    { diagnosis: 'Hypertension', count: 84 },
    { diagnosis: 'Asthma', count: 62 },
    { diagnosis: 'COVID-19', count: 45 },
  ];

  // Bar chart for top diagnoses
  topDiagnosesChartOptions: AgChartOptions = {
    data: this.topDiagnoses,
    series: [
      {
        type: 'bar',
        xKey: 'diagnosis',
        yKey: 'count',
        yName: 'Cases',
        fills: ['#007bff'], // blue bars
      } as AgBarSeriesOptions,
    ],
    axes: [
      { type: 'category', position: 'bottom' },
      { type: 'number', position: 'left' },
    ],
    legend: { enabled: false },
  };

  topDoctors = [
    { name: 'Dr. Thabo Mokoena', city: 'Johannesburg', consultations: 42 },
    { name: 'Dr. Zinhle Dlamini', city: 'Durban', consultations: 39 },
    { name: 'Dr. Pieter van der Merwe', city: 'Cape Town', consultations: 37 },
    { name: 'Dr. Nomsa Nkosi', city: 'Pretoria', consultations: 35 },
    { name: 'Dr. Sipho Khumalo', city: 'Port Elizabeth', consultations: 33 },
    { name: 'Dr. Lerato Mthembu', city: 'Bloemfontein', consultations: 30 },
    { name: 'Dr. Johan de Villiers', city: 'Stellenbosch', consultations: 28 },
    { name: 'Dr. Alice Motsoaledi', city: 'Polokwane', consultations: 26 },
    { name: 'Dr. Themba Sibanda', city: 'Nelspruit', consultations: 25 },
    { name: 'Dr. Sarah Naidoo', city: 'Kimberley', consultations: 24 },
  ];
}
